import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";
import MaterialLocationModal from "./modals/MaterialLocationModal";

function NewMaterialLocation() {
  const [locationName, setLocationName] = useState("");
  const [locationNameList, setLocationNameList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    getLocationNameList();
  }, []);

  const getLocationNameList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://eps.elkomprintama.com/get/api/store/location`,
      );
      setLocationNameList(response.data.result);
    } catch (error) {
      toast.error(error.response.data.msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLocationNameChange = (e) => {
    setLocationName(e.target.value);
  };

  function applyStripedStyle(index) {
    return index % 2 === 0 ? "border-b bg-gray-50" : " bg-white"; // Apply the striped-row class to even-indexed rows
  }

  const insertLocationName = async (e) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `https://eps.elkomprintama.com/post/api/store/location`,
        {
          location_name: locationName.toUpperCase(),
        },
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        getLocationNameList();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!locationName) {
      toast.warning("Please fill in location field");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <>
      <div className={`w-full  rounded-lg `}>
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-2xl text-center  font-bold `}
        >
          New Material Location
        </label>
      </div>
      <div className="relative h-full overflow-x-auto shadow-md px-5 bg-gray-200 sm:rounded-lg">
        <form className="my-5" onSubmit={handleSubmit}>
          <div className="field w-full my-2">
            <div className="control w-full  ">
              <div className="flex flex-wrap -mx-3 mb-5">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="grid-pn"
                  >
                    Location
                  </label>
                  <input
                    className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-pn"
                    type="text"
                    placeholder="Material Location"
                    onChange={handleLocationNameChange}
                    value={locationName.toUpperCase()}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <Button fullSized type="submit">
              Insert
            </Button>
          </div>
        </form>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="text-sm text-left table-auto text-gray-500 dark:text-gray-400 w-full border-collapse">
            <thead className="sticky top-0  text-white uppercase bg-gray-600 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th
                  scope="col"
                  className="whitespace-nowrap px-5 py-5 flex-1 border-r"
                >
                  Location ID
                </th>
                <th scope="col" className="whitespace-nowrap px-5 flex-1">
                  Location Name
                </th>
              </tr>
            </thead>
            <tbody>
              {locationNameList.map((data, index) => (
                <tr
                  onDoubleClick={() => {
                    setShowModal(true);
                    setModalData(data);
                  }}
                  className={`py-6  border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${applyStripedStyle(
                    index,
                  )}`}
                  key={data.product_location_id}
                >
                  <td className="whitespace-nowrap px-5 py-5 flex-1 border-r">
                    {data.product_location_id}
                  </td>
                  <td className="whitespace-nowrap px-5 flex-1">
                    {data.product_location_name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isLoading && <LoadingOverlay message="loading..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              insertLocationName();
              setLocationName("");
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
        {showModal ? (
          <div
            className={`fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex flex-col justify-center items-center`}
            // id="wrapper"
            // onClick={handleClose}
          >
            <MaterialLocationModal
              onClose={() => {
                setShowModal(false);
              }}
              dataSet={modalData}
              refreshData={() => getLocationNameList()}
            ></MaterialLocationModal>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default NewMaterialLocation;
